export default __webpack_public_path__ + "aaaf8287a890d5ad5826558d01b45f13.svg";